import { useSearchParams } from 'next/navigation';
import { useAPI } from '@/services';

interface IUseRegStateOptions {
  enabled?: boolean;
  retry?: boolean;
}

export const useRegState = ({
  enabled = true,
  retry = true,
}: IUseRegStateOptions = {}) => {
  const searchParams = useSearchParams();
  const returnUrl = searchParams?.get('returnUrl');
  const input = returnUrl ? { returnUrl } : {};

  const { isLoading, data, ...rest } = useAPI(['user', 'getCustomerRegState'], {
    input,
    reactQueryOptions: {
      enabled: enabled,
      retry,
    },
  });

  const regStateReturnUrl = data?.returnUrl;
  const isRegisterCompleted = data?.completedRegister;
  const registerMessage = data?.message;
  const backButtonText = ['متوجه شدم، بازگشت به', data?.applicationName].join(
    ' '
  );

  return {
    isLoading,
    data,
    regStateReturnUrl,
    isRegisterCompleted,
    registerMessage,
    backButtonText,
    ...rest,
  };
};
